// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as MapMod from "../map-mods-tbd-catalyst/types/MapMod.bs.js";
import * as Caml_array from "../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactModal from "react-modal";
import * as Interpolation from "../helper/Interpolation.bs.js";
import * as GoogleMapHelper from "./GoogleMapHelper.bs.js";
import * as LegendComponent from "./LegendComponent.bs.js";
import * as MapComponentMod from "../map-mods-tbd-catalyst/views/MapComponentMod.bs.js";
import * as OrderMarkersMapper from "../view-mappers/OrderMarkersMapper.bs.js";
import * as OrderPolylineMapper from "../view-mappers/OrderPolylineMapper.bs.js";
import * as VehicleTracerMapper from "../view-mappers/VehicleTracerMapper.bs.js";
import * as VehicleTracerComponent from "./VehicleTracerComponent.bs.js";
import * as DefaultVehicleLocationMapper from "../view-mappers/DefaultVehicleLocationMapper.bs.js";

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetShowDryRun */0 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: action._0,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetVehicleTimestamp */1 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: action._0,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetVehicleLocation */2 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: action._0,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetErrorModal */3 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: action._0,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetMapLoaded */4 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: action._0,
                popupVisibility: state.popupVisibility
              };
    case /* SetPopupVisibility */5 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: action._0
              };
    
  }
}

function setInterpolationTime(value, order_detail, dispatch) {
  var driverRoute = order_detail.driver_route;
  if (driverRoute !== undefined) {
    var currentLocation = Interpolation.getInterpolatedCoordinate(value, driverRoute.line);
    switch (currentLocation.TAG | 0) {
      case /* Interpolated */0 :
          Curry._1(dispatch, {
                TAG: /* SetErrorModal */3,
                _0: false
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleTimestamp */1,
                _0: {
                  ts: Caml_option.some(value)
                }
              });
          return Curry._1(dispatch, {
                      TAG: /* SetVehicleLocation */2,
                      _0: currentLocation._0
                    });
      case /* ErrorBelowLowest */1 :
          Curry._1(dispatch, {
                TAG: /* SetErrorModal */3,
                _0: true
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: currentLocation._0
              });
          return Curry._1(dispatch, {
                      TAG: /* SetVehicleTimestamp */1,
                      _0: {
                        ts: Caml_option.some(Caml_array.get(driverRoute.line, 0).ts)
                      }
                    });
      case /* ErrorAboveHighest */2 :
          Curry._1(dispatch, {
                TAG: /* SetErrorModal */3,
                _0: true
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: currentLocation._0
              });
          return Curry._1(dispatch, {
                      TAG: /* SetVehicleTimestamp */1,
                      _0: {
                        ts: Caml_option.some(Caml_array.get(driverRoute.line, driverRoute.line.length - 1 | 0).ts)
                      }
                    });
      
    }
  } else {
    Curry._1(dispatch, {
          TAG: /* SetErrorModal */3,
          _0: false
        });
    Curry._1(dispatch, {
          TAG: /* SetVehicleTimestamp */1,
          _0: {
            ts: undefined
          }
        });
    return Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: undefined
              });
  }
}

function markerCount(groupedMarkerList, waypoints) {
  var staticMarker = List.length(List.filter(Belt_Option.isSome)(List.flatten(groupedMarkerList)));
  var waypointMarker = Belt_Option.mapWithDefault(waypoints, 0, (function (arr) {
          return arr.length;
        }));
  return (staticMarker + 1 | 0) + waypointMarker | 0;
}

function OrderMapComponent(Props) {
  var order_detail = Props.order_detail;
  var order_id = Props.order_id;
  var initialState_markers = OrderMarkersMapper.getMarkersViews(order_detail.locations, order_detail.status, order_detail.driver_route);
  var initialState_polylines = OrderPolylineMapper.getPolylineViews(order_detail.trip_started_time, order_detail.driver_route);
  var initialState_tracerControl = {
    ts: undefined
  };
  var initialState_defaultVehicleLocation = DefaultVehicleLocationMapper.getVehicleDefaultLocation(order_detail.status);
  var initialState_popupVisibility = [];
  var initialState = {
    markers: initialState_markers,
    polylines: initialState_polylines,
    showDryRun: true,
    tracerControl: initialState_tracerControl,
    defaultVehicleLocation: initialState_defaultVehicleLocation,
    vehicleLocation: undefined,
    isErrorModalVisible: false,
    isMapLoaded: undefined,
    popupVisibility: initialState_popupVisibility
  };
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetVehicleTimestamp */1,
                _0: {
                  ts: VehicleTracerMapper.getVehicleTracerDefaultTime(state.defaultVehicleLocation, order_detail.driver_route)
                }
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: VehicleTracerMapper.getVehicleDefaultLocation(state.defaultVehicleLocation, order_detail.driver_route)
              });
          
        }), []);
  var centerLocation = OrderMarkersMapper.getMarkerLatLng(order_detail.locations.pickup_loc.location);
  var groupedMarkers = OrderMarkersMapper.groupMarkers(state.markers);
  var onLoad = function (map_inst) {
    var bounds = GoogleMapHelper.getBounds(order_detail);
    map_inst.fitBounds(bounds);
    Curry._1(dispatch, {
          TAG: /* SetPopupVisibility */5,
          _0: Caml_array.make(markerCount(groupedMarkers, state.markers.waypoint), false)
        });
    return Curry._1(dispatch, {
                TAG: /* SetMapLoaded */4,
                _0: Caml_option.some(map_inst)
              });
  };
  var hamburgerMenuHandler = function (menu) {
    if (menu) {
      return Curry._1(dispatch, {
                  TAG: /* SetShowDryRun */0,
                  _0: true
                });
    } else {
      return Curry._1(dispatch, {
                  TAG: /* SetShowDryRun */0,
                  _0: false
                });
    }
  };
  var togglePopupVisibility = function (uid) {
    if (uid >= state.popupVisibility.length) {
      return ;
    }
    var n = state.popupVisibility.length;
    var newArray = Caml_array.make(n, false);
    if (!Caml_array.get(state.popupVisibility, uid)) {
      Caml_array.set(newArray, uid, true);
    }
    return Curry._1(dispatch, {
                TAG: /* SetPopupVisibility */5,
                _0: newArray
              });
  };
  var modalContent = function (param) {
    return React.createElement("div", {
                className: "order-map-modal-container"
              }, React.createElement("div", {
                    className: "message"
                  }, "Selected value is not within the trip time range."), React.createElement("button", {
                    className: "close-button",
                    onClick: (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* SetErrorModal */3,
                                    _0: false
                                  });
                      })
                  }, "Okay"));
  };
  var isTracerPresent = false;
  var match$1 = state.tracerControl.ts;
  var match$2 = order_detail.driver_route;
  var tmp;
  if (match$1 !== undefined && match$2 !== undefined) {
    isTracerPresent = true;
    tmp = React.createElement(VehicleTracerComponent.make, {
          setInterpolationTime: (function (param) {
              return setInterpolationTime(param, order_detail, dispatch);
            }),
          order_status: order_detail.status,
          hamburgerMenuHandler: hamburgerMenuHandler,
          time_stamp: Caml_option.valFromOption(match$1),
          min_date: Caml_array.get(match$2.line, 0).ts,
          max_date: Caml_array.get(match$2.line, match$2.line.length - 1 | 0).ts
        });
  } else {
    tmp = null;
  }
  var map = state.isMapLoaded;
  var tmp$1;
  if (map !== undefined) {
    var map$1 = Caml_option.valFromOption(map);
    tmp$1 = React.createElement(React.Fragment, undefined, GoogleMapHelper.getVehicleMarkerComponent(state.tracerControl.ts, state.vehicleLocation, map$1, Caml_array.get(state.popupVisibility, 0), togglePopupVisibility, order_detail.vehicle_type), GoogleMapHelper.getMarkers(OrderMarkersMapper.multiAnchorPoints, OrderMarkersMapper.singleAnchorPoints, map$1, state.popupVisibility, togglePopupVisibility, groupedMarkers), GoogleMapHelper.getWaypointsMarkersComp(state.markers.waypoint, OrderMarkersMapper.singleAnchorPoints, map$1, state.popupVisibility, togglePopupVisibility), GoogleMapHelper.getBilledPolylineComp(state.polylines.billed), GoogleMapHelper.getDryrunPolylineComp(state.polylines.dry_run, state.showDryRun));
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
              className: "order-map-container"
            }, tmp, React.createElement(MapComponentMod.make, {
                  config: MapMod.make_props("order-map-" + order_id, centerLocation, 11, undefined, undefined, "order-details-map__container order-details-map__canvas " + (
                        isTracerPresent ? "map-with-tracker" : ""
                      ), undefined, undefined, undefined, undefined, onLoad, undefined, undefined, undefined, undefined),
                  children: tmp$1
                }), React.createElement(LegendComponent.make, {}), state.isErrorModalVisible ? React.createElement(ReactModal, {
                    isOpen: true,
                    onRequestClose: (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* SetErrorModal */3,
                                    _0: false
                                  });
                      }),
                    overlayClassName: "porter-form__modal-overlay",
                    className: "porter-form__modal acknowledgeRelaseModal",
                    shouldCloseOnOverlayClick: true,
                    children: modalContent(undefined)
                  }) : null);
}

var make = OrderMapComponent;

export {
  reducer ,
  setInterpolationTime ,
  markerCount ,
  make ,
  
}
/* react Not a pure module */
